import { Component, input, OnChanges } from '@angular/core';
import { AbstractControl, FormArray, FormControl } from '@angular/forms';
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons';

import { Option } from '../../../models/option.model';
import { UiPalette } from '../../../types/UiPalette.type';

@Component({
  selector: 'eiq-checkbox-group',
  templateUrl: 'checkbox-group.component.html',
  styleUrls: ['./checkbox-group.component.scss']
})
export class CheckboxGroupComponent implements OnChanges {
  color = input<UiPalette>('primary');
  expand = input<boolean>(false);
  formCtrl = input(null, {
    transform: (abstractCtrl: AbstractControl) => abstractCtrl as FormArray
  });
  label = input<string>();
  options = input<Option<unknown>[]>([]);
  testId = input<string>();
  tooltip = input<string>(null);

  currentSelected: unknown[] = [];
  faInfoCircle = faInfoCircle;

  ngOnChanges(): void {
    this.currentSelected = this.formCtrl()?.value ?? [];
  }

  mapChecked(optionChecked: Option<unknown>): void {
    const index = this.currentSelected.findIndex((opt) => opt === optionChecked.value);

    if (index > -1) {
      this.formCtrl().removeAt(index);
      this.currentSelected.splice(index, 1);
    } else {
      if (optionChecked.exclusive) {
        this.formCtrl().clear();
        this.currentSelected = [];
      } else {
        const exclusiveIndex = this.currentSelected.findIndex((opt) => {
          const option = this.options().find((o) => o.value === opt);
          return option?.exclusive;
        });
        if (exclusiveIndex > -1) {
          this.formCtrl().removeAt(exclusiveIndex);
          this.currentSelected.splice(exclusiveIndex, 1);
        }
      }
      this.currentSelected.push(optionChecked.value);
      this.formCtrl().push(new FormControl(optionChecked.value));
    }
  }
}
